// A gateway timeout without CORS headers is exposed by Axios as a network error.
// Offer a manual background request; never treat this as a confirmed timeout.
export async function canRequestBackgroundReport (error) {
  if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') return true
  const response = error.response
  if (!response || response.status === 0) {
    return error.code === 'ERR_NETWORK' || error.message === 'Network Error'
  }
  if ([408, 504, 524].includes(response.status)) return true
  if (response.status !== 500 && response.status !== 502 && response.status !== 200) return false
  let body = response.data
  if (typeof Blob !== 'undefined' && body instanceof Blob) {
    if (body.size > 65536) return false
    try {
      body = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsText(body)
      })
    } catch (_) {
      return false
    }
  }
  if (typeof body !== 'string') body = JSON.stringify(body || {})
  return /maximum execution time.{0,40}exceeded|gateway.{0,20}time.?out|timed?\s*out|execution.{0,20}timeout/i.test(body)
}

// The end date is inclusive: Aug 1–Aug 31 is one month; Sep 1 exceeds it.
export function isLongReportPeriod (fromDate, toDate) {
  if (!fromDate || !toDate || toDate < fromDate) return false
  const start = new Date(fromDate + 'T00:00:00Z')
  const end = new Date(toDate + 'T00:00:00Z')
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return false
  const nextMonth = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + 1, 1))
  const lastDay = new Date(Date.UTC(nextMonth.getUTCFullYear(), nextMonth.getUTCMonth() + 1, 0)).getUTCDate()
  nextMonth.setUTCDate(Math.min(start.getUTCDate(), lastDay))
  return end >= nextMonth
}




// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Reports/exportableReportHelpers.js